/*
 * ============================================================
 * JJ – Ergänzungen: Lückenfüller im Warenkorb + «Auch im Set»
 * ============================================================
 * 1) <jj-lueckenfueller> (snippets/jj-lueckenfueller.liquid)
 *    Lädt lieferbare Produkte mit dem Lückenfüller-Tag
 *    (sections/jj-lueckenfueller-daten.liquid), wählt die
 *    passendsten für den fehlenden Betrag aus und zeigt sie
 *    als kleine Karten mit «Hinzufügen».
 *
 * 2) Knöpfe mit [data-jj-add] (z. B. snippets/jj-auch-im-set.liquid)
 *    Legen die Variante aus data-variant mit der versteckten
 *    Eigenschaft _quelle (data-quelle) in den Warenkorb.
 *
 * Nach dem Hinzufügen wird dasselbe Ereignis ausgelöst wie beim
 * normalen Kaufknopf des Themes (product:added), damit sich der
 * Mini-Warenkorb neu aufbaut und öffnet. Auf der Warenkorbseite
 * wird cart:refresh ausgelöst (ohne Neuladen, ohne Hochscrollen).
 * ============================================================
 */
(function () {
  'use strict';

  var CACHE_MS = 10 * 60 * 1000; // Kandidatenliste 10 Minuten zwischenspeichern
  var speicher = {};             // Laufzeit-Zwischenspeicher je URL

  /* ---------------------------------------------------------- */
  /* Hilfsfunktionen                                             */
  /* ---------------------------------------------------------- */

  function routen() {
    return window.routes || {};
  }

  function themeInfo() {
    return window.theme || {};
  }

  function sessionLesen(schluessel) {
    try {
      var roh = window.sessionStorage.getItem(schluessel);
      if (!roh) return null;
      var eintrag = JSON.parse(roh);
      if (!eintrag || Date.now() - eintrag.zeit > CACHE_MS) return null;
      return eintrag.daten;
    } catch (e) {
      return null;
    }
  }

  function sessionSchreiben(schluessel, daten) {
    try {
      window.sessionStorage.setItem(schluessel, JSON.stringify({ zeit: Date.now(), daten: daten }));
    } catch (e) {
      // Privater Modus o. Ä. – dann eben ohne Zwischenspeicher
    }
  }

  // Liest das JSON aus der gerenderten Datensektion.
  function datenAusHtml(html) {
    var dok = new DOMParser().parseFromString(html, 'text/html');
    var skript = dok.querySelector('script[data-jj-lf-daten]');
    if (!skript) return [];
    try {
      var liste = JSON.parse(skript.textContent);
      return Array.isArray(liste) ? liste : [];
    } catch (e) {
      return [];
    }
  }

  function holeKandidaten(url) {
    var schluessel = 'jj-lf:' + url;
    var jetzt = Date.now();

    if (speicher[schluessel] && jetzt - speicher[schluessel].zeit < CACHE_MS) {
      return speicher[schluessel].versprechen;
    }

    var ausSession = sessionLesen(schluessel);
    if (ausSession) {
      var sofort = Promise.resolve(ausSession);
      speicher[schluessel] = { zeit: jetzt, versprechen: sofort };
      return sofort;
    }

    var versprechen = fetch(url, { credentials: 'same-origin' })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
        return antwort.text();
      })
      .then(function (html) {
        var liste = datenAusHtml(html);
        sessionSchreiben(schluessel, liste);
        return liste;
      })
      .catch(function (fehler) {
        delete speicher[schluessel];
        throw fehler;
      });

    speicher[schluessel] = { zeit: jetzt, versprechen: versprechen };
    return versprechen;
  }

  // Hauskonvention "Produktname - Marke": entfernt den Teil nach dem letzten
  // " - " (mit Leerzeichen), unabhängig von der Schreibweise im Feld vendor.
  function kurzTitel(titel) {
    if (!titel) return '';
    var pos = titel.lastIndexOf(' - ');
    return pos > 0 ? titel.slice(0, pos) : titel;
  }

  function element(tag, klasse, text) {
    var el = document.createElement(tag);
    if (klasse) el.className = klasse;
    if (text !== undefined && text !== null) el.textContent = text;
    return el;
  }

  /* ---------------------------------------------------------- */
  /* In den Warenkorb legen                                      */
  /* ---------------------------------------------------------- */

  /*
   * Vermerkt im Warenkorb-Attribut _jj_quellen, welcher Artikel über
   * welchen Block kam, z. B. "auch_im_set:900.023;lueckenfueller:103.816".
   * Das Attribut landet in der Bestellung (Zusätzliche Details / API
   * customAttributes) – auch dann, wenn eine Bundle-Function die Position
   * zerlegt und dabei Positions-Eigenschaften nicht übernimmt.
   */
  var QUELLEN_ATTRIBUT = '_jj_quellen';
  var QUELLEN_MAX = 30;

  function quelleVermerken(quelle, kennung) {
    if (!quelle) return Promise.resolve();
    var r = routen();
    var wurzel = r.rootUrl || '/';
    if (wurzel.slice(-1) !== '/') wurzel += '/';

    return fetch(wurzel + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (antwort) { return antwort.ok ? antwort.json() : null; })
      .then(function (cart) {
        var bisher = (cart && cart.attributes && cart.attributes[QUELLEN_ATTRIBUT]) || '';
        var liste = bisher ? String(bisher).split(';').filter(Boolean) : [];
        liste.push(quelle + ':' + (kennung || ''));
        if (liste.length > QUELLEN_MAX) liste = liste.slice(-QUELLEN_MAX);
        var attribute = {};
        attribute[QUELLEN_ATTRIBUT] = liste.join(';');
        return fetch(wurzel + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ attributes: attribute })
        });
      })
      .catch(function () {
        // Die Nachverfolgung darf das Hinzufügen nie verhindern.
      });
  }

  function inDenWarenkorb(variantenId, quelle, kennung) {
    var r = routen();
    var eintrag = { id: Number(variantenId), quantity: 1 };
    if (quelle) eintrag.properties = { _quelle: quelle };

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    return fetch((r.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [eintrag] })
    })
      .then(function (antwort) {
        return antwort.json().then(function (inhalt) {
          if (!antwort.ok) {
            var fehler = new Error(inhalt.description || inhalt.message || 'Fehler');
            fehler.beschreibung = inhalt.description || '';
            throw fehler;
          }
          return inhalt;
        });
      })
      .then(function (inhalt) {
        return quelleVermerken(quelle, kennung || String(variantenId)).then(function () { return inhalt; });
      })
      .then(function (inhalt) {
        var t = themeInfo();

        if (t.pageType === 'cart') {
          // Warenkorbseite: Abschnitt neu aufbauen, nicht hochscrollen
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { scrollToTop: false }
          }));
        } else if (t.cartType === 'page') {
          window.location.href = r.cartUrl || '/cart';
        } else {
          // Gleiches Ereignis wie der Kaufknopf des Themes: Mini-Warenkorb
          // wird neu gerendert und geöffnet.
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { button: null, variant: null, quantity: 1, productAdded: true }
          }));
        }
        return inhalt;
      })
      .catch(function (fehler) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        throw fehler;
      });
  }

  /* ---------------------------------------------------------- */
  /* Auswahl der Lückenfüller                                    */
  /* ---------------------------------------------------------- */

  /*
   * fehlt     Betrag bis zur Gratisversand-Grenze in Rappen (<= 0: erreicht)
   * toleranz  wie viel teurer als die Lücke ein Artikel sein darf, um
   *           noch als «passt genau» zu gelten (Rappen)
   *
   * Reihenfolge, wenn noch etwas fehlt:
   *   A  schliesst die Lücke knapp (Preis zwischen Lücke und Lücke + Toleranz),
   *      günstigster zuerst
   *   B  bringt näher heran (Preis unter der Lücke), teuerster zuerst
   *   C  schliesst die Lücke, ist aber deutlich teurer, günstigster zuerst
   * Ist die Grenze erreicht: Reihenfolge nach Verkäufen.
   * Danach wird auf Vielfalt geachtet: zuerst je Produkttyp höchstens ein
   * Artikel, erst dann wird aufgefüllt.
   */
  function auswaehlen(liste, fehlt, toleranz, anzahl, imKorb) {
    var kandidaten = liste.filter(function (p) {
      return p && p.v && !imKorb[String(p.id)];
    });

    var geordnet;
    if (fehlt > 0) {
      var a = kandidaten.filter(function (p) { return p.p >= fehlt && p.p <= fehlt + toleranz; })
        .sort(function (x, y) { return x.p - y.p; });
      var b = kandidaten.filter(function (p) { return p.p < fehlt; })
        .sort(function (x, y) { return y.p - x.p; });
      var c = kandidaten.filter(function (p) { return p.p > fehlt + toleranz; })
        .sort(function (x, y) { return x.p - y.p; });
      geordnet = a.concat(b, c);
    } else {
      geordnet = kandidaten;
    }

    // Artikel mit nur einer Variante (Ein-Klick) vor solchen, bei denen die
    // Kundin erst auf der Produktseite wählen muss.
    geordnet = geordnet.filter(function (p) { return !(p.n > 1); })
      .concat(geordnet.filter(function (p) { return p.n > 1; }));

    var wahl = [];
    var typen = {};
    geordnet.forEach(function (p) {
      if (wahl.length >= anzahl) return;
      var typ = (p.ty || '').toLowerCase() || ('id-' + p.id);
      if (typen[typ]) return;
      typen[typ] = true;
      wahl.push(p);
    });
    geordnet.forEach(function (p) {
      if (wahl.length >= anzahl) return;
      if (wahl.indexOf(p) === -1) wahl.push(p);
    });
    return wahl;
  }

  /* ---------------------------------------------------------- */
  /* <jj-lueckenfueller>                                         */
  /* ---------------------------------------------------------- */

  class Lueckenfueller extends HTMLElement {
    connectedCallback() {
      if (this._gestartet) return;
      this._gestartet = true;

      var self = this;
      var url = this.getAttribute('data-quelle');
      if (!url) return;

      // Mini-Warenkorb als Popover (ab 641 px): Vorschläge ausgeschaltet,
      // dort steht nur der Hinweis mit Balken (siehe jj-lueckenfueller.liquid).
      if (this.hasAttribute('data-nur-mobil') && window.matchMedia
          && window.matchMedia('(min-width: 641px)').matches) {
        return;
      }

      holeKandidaten(url)
        .then(function (liste) { self._zeichnen(liste); })
        .catch(function () { /* Ohne Daten bleibt der Block unsichtbar */ });
    }

    _zahl(attribut, standard) {
      var wert = parseInt(this.getAttribute(attribut), 10);
      return isNaN(wert) ? standard : wert;
    }

    _zeichnen(liste) {
      var fehlt = this._zahl('data-fehlt', 0);
      var toleranz = this._zahl('data-toleranz', 1500);
      var anzahl = Math.max(1, Math.min(6, this._zahl('data-anzahl', 3)));

      var imKorb = {};
      (this.getAttribute('data-im-korb') || '').split(',').forEach(function (id) {
        if (id) imKorb[id.trim()] = true;
      });

      var wahl = auswaehlen(liste, fehlt, toleranz, anzahl, imKorb);
      var container = this.querySelector('.jj-lf__liste');
      if (!container || wahl.length === 0) {
        this.hidden = true;
        return;
      }

      container.innerHTML = '';
      var self = this;
      wahl.forEach(function (p) { container.appendChild(self._karte(p)); });

      this.style.setProperty('--jj-lf-spalten', String(wahl.length));
      this.hidden = false;
    }

    _karte(p) {
      var self = this;
      var titel = kurzTitel(p.t);

      var karte = element('div', 'jj-lf__karte');
      karte.setAttribute('role', 'listitem');

      var bildLink = element('a', 'jj-lf__bild');
      bildLink.href = p.u;
      bildLink.tabIndex = -1;
      bildLink.setAttribute('aria-hidden', 'true');
      if (p.i) {
        var bild = document.createElement('img');
        bild.src = p.i;
        bild.alt = '';
        bild.loading = 'lazy';
        bild.width = 150;
        bild.height = 150;
        bildLink.appendChild(bild);
      }
      karte.appendChild(bildLink);

      var name = element('a', 'jj-lf__name', titel);
      name.href = p.u;
      name.title = titel;
      karte.appendChild(name);

      var preis = element('div', 'jj-lf__preis');
      if (p.c && p.c > p.p) {
        preis.appendChild(element('span', 'jj-lf__preis-aktuell jj-lf__preis-aktuell--aktion', p.ph));
        preis.appendChild(element('span', 'jj-lf__preis-vorher', p.ch));
      } else {
        preis.appendChild(element('span', 'jj-lf__preis-aktuell', p.ph));
      }
      karte.appendChild(preis);

      if (p.n > 1) {
        // Mehrere Varianten: zur Produktseite, damit die Kundin wählen kann
        var ansehen = element('a', 'jj-lf__knopf button button--secondary', this.getAttribute('data-text-ansehen'));
        ansehen.href = p.u;
        karte.appendChild(ansehen);
      } else {
        var knopf = element('button', 'jj-lf__knopf button button--primary', '+ ' + this.getAttribute('data-text-hinzufuegen'));
        knopf.type = 'button';
        knopf.setAttribute('aria-label', (this.getAttribute('data-text-hinzufuegen-label') || '').replace('__TITEL__', titel));
        knopf.addEventListener('click', function (ereignis) {
          ereignis.preventDefault();
          ereignis.stopPropagation();
          self._hinzufuegen(p, knopf);
        });
        karte.appendChild(knopf);
      }
      return karte;
    }

    _hinzufuegen(p, knopf) {
      var self = this;
      var meldung = this.querySelector('.jj-lf__meldung');
      var originalText = knopf.textContent;

      knopf.disabled = true;
      knopf.textContent = this.getAttribute('data-text-laedt');
      if (meldung) meldung.hidden = true;

      inDenWarenkorb(p.v, 'lueckenfueller', p.s || String(p.v))
        .then(function () {
          // Normalerweise baut das Theme den Warenkorb neu auf und ersetzt
          // dieses Element. Steht der Knopf danach noch da, zurücksetzen.
          setTimeout(function () {
            if (document.body.contains(knopf)) {
              knopf.disabled = false;
              knopf.textContent = originalText;
            }
          }, 2000);
        })
        .catch(function (fehler) {
          knopf.disabled = false;
          knopf.textContent = originalText;
          if (meldung) {
            meldung.textContent = fehler.beschreibung || self.getAttribute('data-text-fehler');
            meldung.hidden = false;
          }
        });
    }
  }

  if (!window.customElements.get('jj-lueckenfueller')) {
    window.customElements.define('jj-lueckenfueller', Lueckenfueller);
  }

  /* ---------------------------------------------------------- */
  /* Knöpfe [data-jj-add] (z. B. «Auch im Set»)                  */
  /* ---------------------------------------------------------- */

  document.addEventListener('click', function (ereignis) {
    var knopf = ereignis.target.closest ? ereignis.target.closest('[data-jj-add]') : null;
    if (!knopf || knopf.disabled) return;

    // Liegt der Knopf im Produktformular, darf das Formular nicht senden.
    ereignis.preventDefault();
    ereignis.stopPropagation();

    var variante = knopf.getAttribute('data-variant');
    var quelle = knopf.getAttribute('data-quelle') || '';
    var kennung = knopf.getAttribute('data-sku') || variante;
    var textLaedt = knopf.getAttribute('data-text-laedt');
    var textFehler = knopf.getAttribute('data-text-fehler');
    var meldung = null;
    var box = knopf.closest('[data-jj-add-box]');
    if (box) meldung = box.querySelector('[data-jj-add-meldung]');

    var originalHtml = knopf.innerHTML;
    knopf.disabled = true;
    if (textLaedt) knopf.textContent = textLaedt;
    if (meldung) meldung.hidden = true;

    inDenWarenkorb(variante, quelle, kennung)
      .then(function () {
        knopf.disabled = false;
        knopf.innerHTML = originalHtml;
      })
      .catch(function (fehler) {
        knopf.disabled = false;
        knopf.innerHTML = originalHtml;
        if (meldung) {
          meldung.textContent = fehler.beschreibung || textFehler || '';
          meldung.hidden = false;
        }
      });
  }, true);

  /* ---------------------------------------------------------- */
  /* «Auch im Set»: Auswahl bei mehreren Sets                     */
  /* ---------------------------------------------------------- */

  document.addEventListener('change', function (ereignis) {
    var wahl = ereignis.target;
    if (!wahl || !wahl.matches || !wahl.matches('[data-jj-set-wahl]')) return;

    var box = wahl.closest('[data-jj-add-box]');
    if (!box) return;
    var knopf = box.querySelector('[data-jj-set-knopf]');
    var link = box.querySelector('[data-jj-set-link]');

    if (knopf) {
      knopf.setAttribute('data-variant', wahl.value);
      knopf.setAttribute('data-sku', wahl.getAttribute('data-sku') || '');
      var stueck = parseInt(wahl.getAttribute('data-stueck'), 10);
      knopf.textContent = stueck === 2
        ? knopf.getAttribute('data-text-beide')
        : knopf.getAttribute('data-text-set');
      var label = knopf.getAttribute('data-text-label');
      if (label) knopf.setAttribute('aria-label', label.replace('__TITEL__', wahl.getAttribute('data-titel') || ''));
    }
    if (link && wahl.getAttribute('data-url')) {
      link.href = wahl.getAttribute('data-url');
    }
  });

  // Für spätere Erweiterungen und Tests von aussen erreichbar
  window.JJErgaenzungen = {
    auswaehlen: auswaehlen,
    inDenWarenkorb: inDenWarenkorb,
    kurzTitel: kurzTitel,
    quelleVermerken: quelleVermerken
  };
})();
